import styled from 'styled-components'

interface IStatusCardLegacyCollapsibleStyledProps {}

export const StatusCardLegacyCollapsibleStyled = styled.div<IStatusCardLegacyCollapsibleStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  grid-area: collapsible;
`
